import CmsLink from "@/helpers/cms/CmsLink.js";
import CmsComponent from "@/helpers/editor/components/CmsComponent.js";
import CmsComponentBackground from "@/helpers/cms/CmsComponentBackground.js";
import CompatibilityHelper from "@/helpers/CompatibilityHelper.js";

export default class CmsComponentGlyph extends CmsComponent {

    get allowBinding() {
        return true;
    }

    get allowMediaQuery() {
        return true;
    }

    get contentFields() {
        return [`glyph`];
    }

    type = `glyph`

    constructor(data) {
        super(data);

        this.link = this.link ? new CmsLink(this.link) : null;
        this.background = new CmsComponentBackground(this.background);

        if (!data) {
            this.glyph = ``;
            this.size = 32;

            this.color = `inherit`;
            this.spacing = 0;

            // compatibility with Lakeshore Kiosk
            // behavior is different between cms-block-glyphs and other blocks
            this.standalone = false;

            // Item Binding
            this.glyphField = null;
            this.background.active = false;
        } else {
            this.color = CompatibilityHelper.checkColor(this.color);

            if (!data?.background) {
                this.background.active = false;
            }
        }
    }
}
